type ResolveMobileSentryConfigArgs = {
  dsn?: string;
  environment?: string;
  mode: string;
};

export type MobileSentryConfigResult = {
  dsn?: string;
  environment: string;
  reason: "configured" | "missing" | "invalid";
};

const QUOTED_VALUE_PATTERN = /^(?:".*"|'.*')$/;

export const normalizeOptionalEnvValue = (
  value?: string | null,
): string | undefined => {
  if (typeof value !== "string") {
    return undefined;
  }

  let normalized = value.trim();

  while (QUOTED_VALUE_PATTERN.test(normalized)) {
    normalized = normalized.slice(1, -1).trim();
  }

  return normalized.length > 0 ? normalized : undefined;
};

const isSupportedHttpUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

export const resolveMobileSentryConfig = ({
  dsn,
  environment,
  mode,
}: ResolveMobileSentryConfigArgs): MobileSentryConfigResult => {
  const normalizedEnvironment = normalizeOptionalEnvValue(environment) || mode;
  const normalizedDsn = normalizeOptionalEnvValue(dsn);

  if (!normalizedDsn) {
    return {
      environment: normalizedEnvironment,
      reason: "missing",
    };
  }

  if (!isSupportedHttpUrl(normalizedDsn)) {
    return {
      environment: normalizedEnvironment,
      reason: "invalid",
    };
  }

  return {
    dsn: normalizedDsn,
    environment: normalizedEnvironment,
    reason: "configured",
  };
};
